import { render, staticRenderFns } from "./StockCategories.vue?vue&type=template&id=41564fd8"
import script from "./StockCategories.vue?vue&type=script&lang=js"
export * from "./StockCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports